//telas externas
import inicio from '../pages/inicio.vue'

import home from '../pages/home.vue'
import info from '../pages/info.vue'
import dadosComplementares from '../pages/dadosComplementares.vue'
import confirmacao from '../pages/confirmacao.vue'
import foraPeriodo from '../pages/foraPeriodo.vue'
import apiCidadao from '../pages/apiCidadao.vue'
import manutencao from '../pages/manutencao.vue'

import importacaoFamilias from '../pages/admin/importacoes/importacaoFamilias.vue'
import exportacaoFamiliasSemConta from '../pages/admin/exportacoes/exportacaoFamiliasSemConta.vue'
import parametros from '../pages/admin/parametros/parametros.vue'
import parametrosForm from '../pages/admin/parametros/parametrosForm.vue'
import beneficiarios from '../pages/admin/beneficiarios/beneficiarios.vue'
import beneficiosBeneficiarioForm from '../pages/admin/beneficiarios/beneficiosForm.vue'
import beneficiarioForm from '../pages/admin/beneficiarios/beneficiarioForm.vue';
import controlePagamentos from '../pages/admin/beneficiarios/controlePagamentos.vue';
import contaBancaria from '../pages/admin/beneficiarios/contaBancaria.vue';
import arquivocriacaoconta from '../pages/admin/exportacoes/arquivoCriacaoConta.vue'
import importacaoRetornoBuscaConta from '../pages/admin/importacoes/importacaoRetornoBuscaConta.vue'
import importacaoRetornoAberturaConta from '../pages/admin/importacoes/importacaoRetornoAberturaConta.vue'
import visualizarPagamento from '../pages/admin/parametros/visualizarPagamento.vue'
import liberacaoPagamento from '../pages/admin/parametros/liberacaoPagamento.vue'
import parametrosPagamento from '../pages/admin/parametros/parametrosPagamento.vue'
import parametrosPagamentoform from '../pages/admin/parametros/parametrosPagamentoForm.vue'
import beneficiarioFormAlterarResponsavel from '../pages/admin/beneficiarios/beneficiarioFormAlterarResponsavel.vue';
import geracaoParcela from '../pages/admin/parametros/geracaoParcela.vue'

//Relatorios
import beneficiariosSemConta from '../pages/admin/relatorios/beneficiariosSemConta.vue';
import consolidadoPagamento from '../pages/admin/relatorios/consolidadoPagamento.vue';

//Telas de erro
import pagina403 from '../pages/erros/403.vue'
import pagina404 from '../pages/erros/404.vue'
import api from '../requests';
 
//Rota para a correção de um Pagamento anômalo
import configurarPagamento from '../pages/admin/beneficiarios/configurarPagamento.vue'

const verificaPeriodo = async (to, from, next) => {
    
    const result = await api.get('verifica-periodo');
    
    if( result.data.erro === "true" ) {    
        next({name: 'foraperiodo'});
    }else{
        next();
    }
    
}

const routes = [
    {
        name: 'home',
        path: '/',
        component: home,
        meta: {
        },
        beforeEnter: verificaPeriodo
    },
    {
        name: 'info',
        path: '/info',
        component: info,
        meta: {
            breadcrumbs: [ 
                {
                    label: 'Busca Beneficiário',
                    link: '/'
                },
                {
                    label: 'Benefícios'
                },
            ]
        },
    },
    {
        name: 'dadoscomplementares',
        path: '/dados-complementares',
        component: dadosComplementares,
    },
    {
        name: 'confirmacao',
        path: '/confirmacao',
        component: confirmacao,
        meta: {
            breadcrumbs: [ 
                {
                    label: 'Busca Beneficiário',
                    link: '/'
                },
                {
                    label: 'Confirmação'
                },
            ]
        },
    },
    {
        name: 'foraperiodo',
        path: '/fora-periodo',
        component: foraPeriodo,
    },
    {
        name: 'inicio',
        path: '/inicio',
        component: inicio,
    },


    {
        name: 'importacaofamilias',
        path: '/admin/importacao-familias',
        component: importacaoFamilias,
        meta: {
            breadcrumbs: [
                {
                    label: 'Importação de Famílias'
                }
            ]
        }
    },
    {
        name: 'importacaoRetornoBuscaConta',
        path: '/admin/importacao-busca-contas',
        component: importacaoRetornoBuscaConta,
        meta: {
            breadcrumbs: [
                {
                    label: 'Importação de Arquivo de contas verificadas'
                }
            ]
        }
    },

    {
        name: 'importacaoRetornoAberturaConta',
        path: '/admin/importacao-abertura-contas',
        component: importacaoRetornoAberturaConta,
        meta: {
            breadcrumbs: [
                {
                    label: 'Importação de Arquivo de contas criadas'
                }
            ]
        }
    },

    {
        name: 'exportacaofamiliassemconta',
        path: '/admin/exportacao-familias-sem-conta',
        component: exportacaoFamiliasSemConta,
        meta: {
            breadcrumbs: [
                {
                    label: 'Exportação de Arquivo para busca de contas'
                }
            ]
        }
    },

    {
        name: 'arquivocriacaoconta',
        path: '/admin/arquivo-criacao-conta',
        component: arquivocriacaoconta,
        meta: {
            breadcrumbs: [
                {
                    label: 'Exportação de Arquivo para criação de contas'
                }
            ]
        }
    },


    {
        name: 'parametros',
        path: '/admin/parametros',
        component: parametros,
        meta: {
            breadcrumbs: [
                {
                    label: 'Parâmetros'
                }
            ]
        }
    },
    {
        name: 'parametrosPagamento',
        path: '/admin/parametros-pagamento',
        component: parametrosPagamento,
        meta: {
            breadcrumbs: [
                {
                    label: 'Parâmetro Pagamento'
                }
            ]
        }
    },
    {
        name: 'visualizarPagamento',
        path: '/admin/visualizar-pagamento',
        component: visualizarPagamento,
        meta: {
            breadcrumbs: [
                {
                    label: 'Gerar/Enviar Arquivo de Pagamento'
                }
            ]
        }
    },

    {
        name: 'liberacaoPagamento',
        path: '/admin/liberacao-pagamento-erro',
        component: liberacaoPagamento,
        meta: {
            breadcrumbs: [
                {
                    label: 'Liberação de Pagamentos com Erro'
                }
            ]
        }
    },


    {
        name: 'geracaoParcela',
        path: '/admin/gerar-parcela',
        component: geracaoParcela,
        meta: {
            breadcrumbs: [
                {
                    label: 'Gerar Parcela'
                }
            ]
        }
    },

    {
        name: 'parametrosform',
        path: '/admin/parametros/:id',
        component: parametrosForm,
        props: true,
        meta: {
            breadcrumbs: [ 
                {
                    label: 'Parâmetros',
                    link: '/admin/parametros'
                },
                {
                    label: 'Formulário Parâmetros'
                },
            ]
        },
    },

    {
        name: 'parametrosPagamentoform',
        path: '/admin/parametros-pagamento/:id',
        component: parametrosPagamentoform,
        props: true,
        meta: {
            breadcrumbs: [ 
                {
                    label: 'Parâmetro Pagamento',
                    link: '/admin/parametros-pagamento'
                },
                {
                    label: 'Data do Pagamento'
                },
            ]
        },
    },
  
    {
        name: 'manutencao',
        path: '/admin/manutencao',
        component: manutencao,
        props: true,
        meta: {
            breadcrumbs: [ 
                {
                    label: 'Manutenção do Sistema'
                },
            ]
        },
    },

    {
        name: 'beneficiarios',
        path: '/admin/beneficiarios',
        component: beneficiarios,
        meta: {
            breadcrumbs: [
                {
                    label: 'Beneficiários'
                }
           ]
        }   
    },
    {
        name: 'beneficiarioForm',
        path: '/admin/beneficiarios/:id',
        component: beneficiarioForm,
        meta: {
            breadcrumbs: [
                {
                    label: 'Editar Beneficiário'
                }
            ]
        }
    },
    {
        name: 'beneficiosbeneficiarioForm',
        path: '/admin/beneficiarios/:id/beneficios',
        component: beneficiosBeneficiarioForm,
        meta: {
            breadcrumbs: [
                {
                    label: 'Beneficiários',
                    link: '/admin/beneficiarios'
                },
                {
                    label: 'Benefícios'
                },
            ]
        },                            
    },
    {
        name: 'controlePagamentos',
        path: '/admin/beneficiarios/:id/controle-pagamentos',
        component: controlePagamentos,
        props: true,
        meta: {
            breadcrumbs: [
                {
                    label: 'Beneficiários',
                    link: '/admin/beneficiarios'
                },
                {
                    label: 'Controle Pagamentos'
                },
            ]
        },                            
    },
    {
        name: 'contaBancaria',
        path: '/admin/beneficiarios/:id/conta-bancaria',
        component: contaBancaria,
        props: true,
        meta: {
            breadcrumbs: [
                {
                    label: 'Beneficiários',
                    link: '/admin/beneficiarios'
                },
                {
                    label: 'Conta Bancária'
                },
            ]
        },                            
    },

    {
        name: 'beneficiarioFormAlterarResponsavel',
        path: '/admin/beneficiario/alterar-responsavel/:id',
        component: beneficiarioFormAlterarResponsavel,
        meta: {
            breadcrumbs: [
                {
                    label: 'Solicitar Novo Responsável'
                }
            ]
        }
    },

    {
        name: 'beneficiariosSemConta',
        path: '/admin/relatorios',
        component: beneficiariosSemConta,
        meta: {
            breadcrumbs: [
                {
                    label: 'Relatórios'
                },
                {
                    label: 'Beneficiários sem Conta'
                }
            ]
        }
    },

    {
        name: 'consolidadoPagamento',
        path: '/admin/relatorios/pagamentos-consolidados',
        component: consolidadoPagamento,
        meta: {
            breadcrumbs: [
                {
                    label: 'Relatórios'
                },
                {
                    label: 'Status Pagamento'
                }
            ]
        }
    },

    {
        name: 'configurarPagamento',
        path: '/admin/configurar-pagamento',
        component: configurarPagamento,
        meta: {
            breadcrumbs: [
                {
                    label: 'Corrigir Pagamento'
                }
            ]
        }
    },

    {
        name: '403',
        path: '/403',
        component: pagina403,
    },
    //tela "não encontrada"
    {
        path: '*',
        name: '/404',
        component: pagina404,
    },
    //tela para disparar job api cidadão
    {
        name: 'apiCidadao',
        path: '/buscar-cidadao',
        component: apiCidadao,
    },
];

export default routes;